import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updatePartnerCardDetails } from 'modules/accommodations/features/reservations/api';

export const useMutationPartnerCardDetails = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  const {
    mutateAsync: updatePartnerCardDetailsMutation,
    isLoading: updatePartnerCardDetailsMutationIsLoading,
  } = useMutation(updatePartnerCardDetails, {
    onSuccess: () => {
      successToast(t('Card information successfully updated'));
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_ACCOMMODATION_PARTNER_CARD_DETAILS);
    },
    onError: () => errorToast(),
  });

  return { updatePartnerCardDetailsMutation, updatePartnerCardDetailsMutationIsLoading };
};
